import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { TransActionResult,Country, Currency, Attribute, AssetType, OperationType, NearBy,FileUpload } from '@app/_models'; 
import { environment } from '@environments/environment';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
    providedIn: 'root'
  })
export class AppService {
    baseUrl: string;
    _http: HttpClient;

//    siteLang: string ='en';
    siteDir: string = 'ltr';
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }
    constructor(private http: HttpClient) {
        this.baseUrl = `${environment.apiUrl}`;
        this._http = http;
    }
    public siteLangSubject: BehaviorSubject<string>=new BehaviorSubject<string>('en');;

    changeSiteLang(value: string) {
        this.siteLangSubject.next(value);
    }
    
    public get SiteLang(): string {
        return this.siteLangSubject.value;
    }
    getCountries(): Observable<Country[]> {
        return this._http.get<Country[]>(this.baseUrl + '/Asset/GetCountries')
            .pipe(
                catchError(this.handleError)
            );
    }

    getCurrencies(): Observable<Currency[]> {
        return this._http.get<Currency[]>(this.baseUrl + '/Asset/GetCurrencies')
            .pipe(
                catchError(this.handleError)
            );
    }
    getAssetAttributes(): Observable<Attribute[]>  {
        return this._http.get<Attribute[]>(this.baseUrl + '/Asset/GetAssetAttributes')
            .pipe(
            catchError(this.handleError)
        );
    }
    getNearByList(): Observable<NearBy[]>  {
        return this._http.get<NearBy[]>(this.baseUrl + '/Asset/GetNearBy')
            .pipe(
            catchError(this.handleError)
        );
    }
    getAssetTypes(): Observable<AssetType[]>{
        return this._http.get<AssetType[]>(this.baseUrl + '/Asset/GetAssetTypes')
            .pipe(
                catchError(this.handleError)
            );
    }
    getOperationTypes(): Observable<OperationType[]>{
        return this._http.get<OperationType[]>(this.baseUrl + '/Asset/GetOperationTypes')
            .pipe(
                catchError(this.handleError)
            );
    }

    getUploadFiles(fileUpload: FileUpload): Observable<TransActionResult> {
        return this._http.post<TransActionResult>(this.baseUrl + '/Upload/GetUploadFiles', fileUpload, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    saveUploadFile(fileUpload: FileUpload): Observable<TransActionResult> {
        return this._http.post<TransActionResult>(this.baseUrl + '/Upload/saveUploadFile', fileUpload, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
    getNotifications(user: string, pageSize: number, pageNo:number ): Observable<TransActionResult> {
        return this._http.get<TransActionResult>(this.baseUrl + '/Asset/GetNotificationsForUser?id='+user+'&PageSize='+pageSize+'&PageNo='+pageNo)
            .pipe(
                catchError(this.handleError)
            );
    }
    // Handle API errors
    handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(
            'Something bad happened; please try again later.');
    };
    private log(message: string) {
        console.log(message);
    }

}
